export default __webpack_public_path__ + "static/media/copy.8ac04b1b.svg";